// This is a subclassing mechanism for summary data services for searches and watches
// that  allows for two separate data sources.

// Unfortunately it does not seem to survive minification and bundling, so requires special handling


//-------------------------------------------------------------------------
// If this is the base service...
//var projectSummaryDataService = EICDataStream3Search.factory('projectSummaryDataService', ['$rootScope', '$timeout', '$state', '$stateParams', 'searchService', 'savedSearches', 'projects', 'trackingStatusService', 'projectDataService',
var projectSummaryDataService = function ($rootScope, $timeout, $state, $stateParams, searchService, projects, trackingStatusService, projectDataService) {
  var projectSummaryDataService = {};

  // setting the current (default) set of tracking statuses should 
  // be in the controller or else the default never gets set
  // on the other hand, this allos there to be a 'session' value that 
  // carries across searches
  //Favourites and project watches should always implement all tracking statuses
  // Project Criteria Watches should implement whatever was set at time of creation
  // projectSummaryDataService.selectedTrackingStatuses = [1, 3];
  trackingStatusService.selectedValues = [1, 3];
  projectSummaryDataService.searchURL = "";

  // Initialise dataFlowControl
  projectSummaryDataService.dataFlowControl = {
    busy: false,
    loading: false,
    cancelLoading: false,
    moreSummaries: false,
    items: []
  };

  projectSummaryDataService.trackingStatusCounts = {};

  // flow control is also done here for backward conpatability
  projectSummaryDataService.busy = false;
  projectSummaryDataService.loading = false;
  projectSummaryDataService.moreSummaries = false;

  //projectSummaryDataService.search = function (searchGuid, initialSort) {
  //  var i=0;
  //};


  projectSummaryDataService.startSearch = function (savedSearchDefinition, initialSort, source) {
    if (savedSearchDefinition.resubmit) {
      // $state.go("search.projectSummary", {searchID:savedSearchDefinition.guid, searchName: savedSearchDefinition.searchName})
      var resubmitParameters = savedSearchDefinition.resubmitParameters
      // $state.go(resubmitParameters.route, {searchID:resubmitParameters.guid, searchName: resubmitParameters.name})
      $state.go(resubmitParameters.route, { guid: resubmitParameters.guid, name: resubmitParameters.name })


    }

    searchService.queryDef.apply(savedSearchDefinition);
    projectSummaryDataService.queryDef = searchService.queryDef;

    if (initialSort) {
      searchService.queryDef.sorting.sort_order = initialSort.sortField;
      searchService.queryDef.sorting.sort_desc = initialSort.sortDesc;

      searchService.queryDef.paging = {
        limit: 20,
        offset: 0
      };
    }

    projectSummaryDataService.dataFlowControl.cancelLoading = false;
    projectSummaryDataService.cancelLoading = false; // flow control is also done here for backward conpatability

    projectSummaryDataService.totalResultsCount = 0;
    projectSummaryDataService.dataFlowControl.items.length = 0;
    // projectSummaryDataService.items = [];

    projectSummaryDataService.dataFlowControl.moreSummaries = false;
    projectSummaryDataService.moreSummaries = false;// flow control is also done here for backward conpatability

    projectSummaryDataService.projectSearch(source);
  };


  projectSummaryDataService.showDataErrorMessage = function (message) {
    projectSummaryDataService.dataErrorMessage = message;
    $timeout(function () {
      projectSummaryDataService.dataErrorMessage = "";
    }, 7000);
  };


  projectSummaryDataService.projectSearch = function (source) {
    // If a search is done based on a direct route transition via a url, we need to  fetch the
    // query definition

    // Cancel loading is typically set to  avoid a residual page fro being loaded
    // by InfiniteScroll when the route is changed and a new search is about to begin
    if (projectSummaryDataService.dataFlowControl.cancelLoading || projectSummaryDataService.cancelLoading) return;


    // in order to  perform the search, we mus either have search criteria, or a list of projects
    var criteriaSupplied = searchService.queryDef.criteria && searchService.queryDef.criteria != "";
    var projectListSupplied = searchService.queryDef.projectIDs && searchService.queryDef.projectIDs.length > 0;

    if (criteriaSupplied || projectListSupplied) {
      projectSummaryDataService.dataFlowControl.busy = true;
      projectSummaryDataService.dataFlowControl.loading = true;

      projects.query({
        guid: searchService.queryDef.guid,
        paging: JSON.stringify(searchService.queryDef.paging),
        sorting: JSON.stringify(searchService.queryDef.sorting),
        source: source
      }, //: JSON.stringify(searchService.queryDef) },
        function (items) {
          projectSummaryDataService.dataFlowControl.loading = false;
          projectSummaryDataService.dataFlowControl.items = projectSummaryDataService.dataFlowControl.items.concat(items[0].summaries);

          // project names are only sent down with the first page;
          // they do not need to be refreshed with subsequent pages
          if (items[0].projectNames) {
            projectDataService.projectNames = items[0].projectNames;

            // create an associative array of projectName objects for easy  retrieval
            // by projectID
            projectDataService.projectNameLookup = {};
            for (var i = 0, len = projectDataService.projectNames.length; i < len; i++) {
              projectDataService.projectNameLookup[projectDataService.projectNames[i].projectID] = projectDataService.projectNames[i];
            }

            trackingStatusCount(items[0].projectNames);

            $rootScope.$broadcast("PROJECTNAMES_FETCHED", items[0].projectNames, searchService.queryDef.sorting);
          }

          projectSummaryDataService.dataFlowControl.moreSummaries = projectSummaryDataService.trackingStatusCounts.totalResultsCount > projectSummaryDataService.dataFlowControl.items.length;
          console.log(projectSummaryDataService.dataFlowControl);
          projectSummaryDataService.dataFlowControl.busy = false;

        },
        function (e, e1, e2) {
          showDataErrorMessage("There was an error and the next page of data failed to load");
        });
    }

  };

  ////////////////////////////////////////////////////////////////////
  var initTrackingStatusCount = function () {
    projectSummaryDataService.trackingStatusCounts.totalResultsCount = 0;

    projectSummaryDataService.trackingStatusCounts.active = 0;
    projectSummaryDataService.trackingStatusCounts.dormant = 0;
    projectSummaryDataService.trackingStatusCounts.future = 0;
    projectSummaryDataService.trackingStatusCounts.archived = 0;
    projectSummaryDataService.trackingStatusCounts.deleted = 0;
    projectSummaryDataService.trackingStatusCounts.cancelled = 0;
  }

  var trackingStatusCount = function (projectNames) {
    initTrackingStatusCount();
    var l = projectNames.length;

    projectSummaryDataService.trackingStatusCounts.totalResultsCount = l;

    for (var i = 0; i < l; i++) {
      switch (projectNames[i].trackingStatusID) {
        case 1:
          projectSummaryDataService.trackingStatusCounts.active++;
          break;
        case 2:
          projectSummaryDataService.trackingStatusCounts.dormant++;
          break;
        case 3:
          projectSummaryDataService.trackingStatusCounts.future++;
          break;
        case 4:
          projectSummaryDataService.trackingStatusCounts.archived++;
          break;
        case 5:
          projectSummaryDataService.trackingStatusCounts.deleted++;
          break;
        case 6:
          projectSummaryDataService.trackingStatusCounts.cancelled++;
          break;
        default:

      }
    }

  };
  ////////////////////////////////////////////////////////////////////


  projectSummaryDataService.nextPage = function (source) {
    // Guard conditions to prevent a search from runnning
    // i. search already in progress
    // ii. change of subject causing a nexpPage() call with no search criteria
    var noCriteriaSupplied = !searchService.queryDef.criteria || Object.keys(searchService.queryDef.criteria).length == 0;
    var noProjectListSupplied = !searchService.queryDef.projectIDs || searchService.queryDef.projectIDs.length == 0;

    if (projectSummaryDataService.dataFlowControl.busy) return;
    if (noCriteriaSupplied && noProjectListSupplied) return;

    // searchService.queryDef.paging.offset = searchService.queryDef.paging.offset + searchService.queryDef.paging.limit;
    searchService.queryDef.incrementPage();
    projectSummaryDataService.projectSearch(source);
  };



  return projectSummaryDataService;
};

//]);
//-------------------------------------------------------------------------



// Based in this post:
// http://stackoverflow.com/questions/26642174/angularjs-service-inheritance
// I can create new instances based on the prototype like this:
function projectSearchSummaryDataService(projectSummaryDataService, savedSearches) {
  angular.extend(projectSearchSummaryDataService.prototype, projectSummaryDataService);
  var that = this;

  // We implement the methods that vary in the child
  this.search = function (searchGuid, initialSort) {
    if (!this.isProject) {

      this.dataFlowControl.cancelLoading = true;
      this.dataFlowControl.items.length = 0;


      savedSearches.get({ guid: searchGuid },
        function (savedSearchDefinition) {
          angular.extend(that.dataFlowControl, savedSearchDefinition);
          that.startSearch(savedSearchDefinition, initialSort);
        }
        ,
        function (e1, e2) {
          that.showDataErrorMessage("There was an error and the search failed to start");
        }
      );
    }
  };
}







// Watches
// We implement the methods that vary in the child
// In this case, it is the search method because that  is what brings down
// the search criteria, whose location varies based on the useage
function projectWatchSummaryDataService(projectSummaryDataService, projectWatch) {
  angular.extend(projectWatchSummaryDataService.prototype, projectSummaryDataService);
  var that = this;

  this.search = function (watchGuid, initialSort) {
    if (!this.isProject) {
      this.dataFlowControl.cancelLoading = true;
      this.dataFlowControl.items.length = 0;

      projectWatch.get({ guid: watchGuid },
        function (watchDefinition) {
          //that.dataFlowControl.queryDef = watchDefinition;
          angular.extend(that.dataFlowControl, watchDefinition);

          that.startSearch(watchDefinition, initialSort);
        }
        ,
        function (e1, e2) {
          that.showDataErrorMessage("There was an error and the search failed to start");
        }
      );

    }
  };
}


// PDF Reports
// We implement the methods that vary in the child
// In this case, it is the search method because that  is what brings down
// the search criteria, whose location varies based on the useage
function projectReportSummaryDataService(projectSummaryDataService, pdfReportService) {
  angular.extend(projectReportSummaryDataService.prototype, projectSummaryDataService);
  var that = this;

  this.search = function (reportId, sortOrder) {
    // search uses projectids from the report definition
    // usubf rgw projectID filter to get the project summary

    if (!this.isProject) {
      this.dataFlowControl.cancelLoading = true;
      this.dataFlowControl.items.length = 0;

      pdfReportService.getReport(reportId)
        .then(function(reportDefinition) {
            angular.extend(that.dataFlowControl, reportDefinition);
            if (!sortOrder) sortOrder = { sortField: reportDefinition.sortOrder, sortDesc: reportDefinition.sortDesc };

            that.startSearch(reportDefinition, sortOrder, "pdfreport");
          },
          function(e1, e2) {
            that.showDataErrorMessage("There was an error and the search failed to start");
          });

    }
  };
}



// Recently Added Projects
// We implement the methods that vary in the child
// In this case, it is the search method because that is what brings down
// the search criteria, whose location varies based on the useage
function recentlyAddedProjectsSummaryDataService(projectSummaryDataService, searchService, projectDataService, recentlyAddedProjects) {
  angular.extend(recentlyAddedProjectsSummaryDataService.prototype, projectSummaryDataService);
  var that = this;

  //var selectedIndustrySectorIDs =[];
  //$scope.$watch("criteria.selectedIndustrySectors", function(newlist, oldlist) {
  //  // translate selected IndustrySectors to selected Industry Sector IDs
  //  selectedIndustrySectorIDs = searchService.queryDef.criteria.selectedIndustrySectors.map(function(item){
  //    return item.id;
  //  });
  //});

  this.search = function(createdWithinWeeks, sortOrder){
    if(!sortOrder) sortOrder = {sortField: "Created", sortDesc: true};

    this.createdWithinWeeks = createdWithinWeeks;
   // that.dataFlowControl.items = [];
    recentlyAddedProjects
      .query({createdWithinWeeks:createdWithinWeeks,
              selectedEnergySectors: searchService.queryDef.criteria.selectedIndustrySectorIDs,
              sortField: sortOrder.sortField,
              sortDesc:sortOrder.sortDesc
        })
      .$promise.then(function(data){
        that.dataFlowControl.items = data;

        // use the returned data to populate a list of project names for the prev/next functions
        projectDataService.projectNames = data.map(function(item){
          return{
            isChecked:false,
            name: item.projectName,
            projectID :item.projectID,
            trackingStatusID: item.trackingStatusID
          };
        });

        projectDataService.projectNameLookup = {};
        for (var i = 0, len = projectDataService.projectNames.length; i < len; i++) {
          projectDataService.projectNameLookup[projectDataService.projectNames[i].projectID] = projectDataService.projectNames[i];
        }
      }
    );
  };

  this.sort = function(sort){
    this.search(this.createdWithinWeeks, sort);
  };

  //
  //this.search = function(createdSince){
  //  this.createdSince = createdSince;
  //  //that.dataFlowControl.items.length = 0;
  //  //that.dataFlowControl.limit = 20;
  //  //that.dataFlowControl.offset = 0;
  //  that.dataFlowControl.items = [];
  //  that.dataFlowControl.items = recentlyAddedProjects
  //    .query({createdSince:createdSince,
  //      selectedEnergySectors: searchService.queryDef.criteria.selectedIndustrySectorIDs
  //      //,
  //      //    limit:that.dataFlowControl.limit,
  //      //offset:0
  //    });
  //  //.$promise.then(function(data){
  //  //    that.dataFlowControl.items.concat(data,e);
  //  //    that.dataFlowControl.offset = that.dataFlowControl.offset + that.dataFlowControl.limit;
  //  //  })
  //  //  .error(function(e, a, b){
  //  //    var i=0;
  //  //  });
  //};

  //this.nextPage = function(){
  //
  //  recentlyAddedProjects
  //    .query({createdSince: this.createdSince,
  //            selectedEnergySectors: searchService.queryDef.criteria.selectedIndustrySectorIDs,
  //            limit:that.dataFlowControl.limit,
  //            offset:that.dataFlowControl.offset})
  //    .$promise.then(function(data){
  //      that.dataFlowControl.items.concat(data);
  //      that.dataFlowControl.offset = that.dataFlowControl.offset + that.dataFlowControl.limit;
  //    });
  //
  //};


}



// Add a reference to  the search module  so that these services can be added to  it
var EICDataStream3Search = angular.module("EICDataStream3.search");

EICDataStream3Search
  .service('projectSummaryDataService', ['$rootScope', '$timeout', '$state', '$stateParams', 'searchService', 'projects', 'trackingStatusService', 'projectDataService', projectSummaryDataService])
  .service('projectSearchSummaryDataService', ['projectSummaryDataService', 'savedSearches', projectSearchSummaryDataService])
  .service('projectWatchSummaryDataService', ['projectSummaryDataService', 'projectWatch', projectWatchSummaryDataService])
  .service('recentlyAddedProjectsSummaryDataService', ['projectSummaryDataService','searchService', 'projectDataService', 'recentlyAddedProjects', recentlyAddedProjectsSummaryDataService])
  .service('projectReportSummaryDataService', ['projectSummaryDataService', 'pdfReportService', projectReportSummaryDataService]);






// There is no reason why favourite lists can't be done in the same way